import amplitudePlugin from './amplitude-plugin';

export { default as amplitudePlugin } from './amplitude-plugin';

export default {
  amplitudePlugin,
};
